import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Title from '../../SpiderWebSite/components/Title'
import { IReduxState } from '../../store'
import { ISouscripteur, setListeEtabsSouscrit } from '../../store/focusEcoleSlice'
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../util/apiClient'
import { anneescolaire } from '../../util/constant'
import Liste from './Liste'
import SearchBar from './SearchBar'





export default function EtabsSouscritFocusEcole() {


    const dispatch = useDispatch();
    const listeEtabsSouscrit = useSelector((state: IReduxState) => state.focusEcole.listeEtabsSouscrit);

    // const [filteredListe, setFilteredListe] = useState([...listeEtabsSouscrit])
    const [filteredListe, setFilteredListe] = useState<Array<any>>(listeEtabsSouscrit || []);

    const [currentEtab, setCurrentEtab] = useState<any>({})
    const [open, setOpen] = useState(false)
    const [addLoading, setAddLoading] = useState(false)
    const [localArraySouscripteur, setLocalArraySouscripteur] = useState<ISouscripteur[]>([])
    const [search, setSearch] = React.useState("");

    const [currentYear, setCurrentYear] = useState<any>({})
    const [loadingGetTuteur, setLoadingGetTuteur] = useState(false)

    const updateFilteredListe = (etab: any) => {
        const etabFound = filteredListe.map((item: any) =>
            item.codeEtab === etab.codeEtab
                &&
                item.anneeScolaire === etab.anneeScolaire
                ? etab
                : item
        )
        setFilteredListe(etabFound)
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };


    const filterFunction = () => {
        if (search.length === 0) {
            setFilteredListe([...listeEtabsSouscrit]);
        } else {
            const result: any = listeEtabsSouscrit.filter(
                (item: ISouscripteur, index: number) => {
                    const value: any = `${item.codeEtab}`;
                    return value.toLowerCase().includes(search.toLowerCase());
                }
            );
            setFilteredListe(result);
        }
    };

    // React.useEffect(() => {
    //     filterFunction();
    // }, [search]);


    React.useEffect(() => {
        if (Array.isArray(listeEtabsSouscrit)) {
            filterFunction();
        }
    }, [search, listeEtabsSouscrit]);



    // const getListeEtabsSouscrit = async () => {
    //     try {
    //         const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getetabfocusecole/${anneescolaire}`);
    //         if (res.status === 1) {
    //             dispatch(setListeEtabsSouscrit(res.data))
    //         } else {
    //             console.log("else getListeEtabsSouscrit")
    //         }
    //     } catch (error) {
    //         console.log("🚀 ~ getListeEtabsSouscrit ~ error:", error)
    //     }
    // };

    const getListeEtabsSouscrit = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getetabfocusecole/${anneescolaire}`);

            // Vérifie si les données retournées par l'API (res.data) est un tableau.
            if (res.status === 1 && Array.isArray(res.data)) {
                dispatch(setListeEtabsSouscrit(res.data));
            } else {
                console.log("else getListeEtabsSouscrit")
            }
        } catch (error) {
            console.log("🚀 ~ getListeEtabsSouscrit ~ error:", error);
        }
    };



    useEffect(() => {
        getListeEtabsSouscrit()
    }, [])




    return (
        <Box>
            <Grid container spacing={2} style={{ background: "#F7F7F7", padding: '16px' }}>
                {/* Colonne 1 */}
                <Grid item xs={6}>
                    <Title intitule="Liste des établissements" />
                </Grid>

                {/* Colonne 2 */}
                <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <SearchBar setSearch={setSearch} />
                </Grid>
            </Grid>

            {/* <Liste
                filteredListe={filteredListe}
                setFilteredListe={setFilteredListe}
                updateFilteredListe={updateFilteredListe}
            /> */}

            <Liste
                filteredListe={Array.isArray(filteredListe) ? filteredListe : []}
                setFilteredListe={setFilteredListe}
                updateFilteredListe={updateFilteredListe}
            />
        </Box>
    )
}
